module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Classroom-Support",
      "fill": "#050C14"
    }
  }, [_c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M52,55 C52,47.4209778 49.166838,40.9393937 42.3960656,38.3093404 C42.3960656,38 45.1550374,35.9419596 45.1550374,31.2152181 C45.1550374,26.0006673 40.9456107,21 35,21 C28.6091645,21 24.8106527,26.6537863 24.8106527,31.2152181 C24.8106527,35.1324951 26.9187744,37.5135742 27.6330212,38.296833 C20.839981,40.9187994 18,47.4089355 18,55 C20.2454357,55 48.6863763,55 52,55 Z",
      "id": "Oval-2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle",
      "x": "34",
      "y": "4",
      "width": "2",
      "height": "10",
      "rx": "1"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle",
      "transform": "translate(50.000000, 13.000000) rotate(-315.000000) translate(-50.000000, -13.000000) ",
      "x": "49",
      "y": "8",
      "width": "2",
      "height": "10",
      "rx": "1"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle",
      "transform": "translate(20.000000, 13.000000) rotate(-45.000000) translate(-20.000000, -13.000000) ",
      "x": "19",
      "y": "8",
      "width": "2",
      "height": "10",
      "rx": "1"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle",
      "transform": "translate(12.000000, 23.000000) rotate(-75.000000) translate(-12.000000, -23.000000) ",
      "x": "11",
      "y": "18",
      "width": "2",
      "height": "10",
      "rx": "1"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle",
      "transform": "translate(58.000000, 23.000000) scale(-1, 1) rotate(-75.000000) translate(-58.000000, -23.000000) ",
      "x": "57",
      "y": "18",
      "width": "2",
      "height": "10",
      "rx": "1"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18.9159265,44.1633367 C18.3540958,43.7976614 17.739377,43.480837 17.069586,43.2183579 C17.069586,43 19,41.5472656 19,38.2107422 C19,3s4.5298828 16.054723,31 11.8946623,31 C7.42308404,31 4.76531844,34.990908 4.76531844,38.2107422 C4.76531844,40.9758789 6.24034175,42.6566406 6.74009027,43.2095292 C1.987095,45.060329 0,49.6416016 0,55 C1.04319508,55 9.44323665,55 16.1356689,55 C16.1356689,51.6461182 16.716342,46.821167 18.9159265,44.1633367 Z",
      "id": "Oval-2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.0840735,44.1633367 C51.6459042,43.7976614 52.260623,43.480837 52.930414,43.2183579 C52.930414,43 51,41.5472656 51,38.2107422 C51,34.5298828 53.945277,31 58.1053377,31 C62.576916,31 65.2346816,34.990908 65.2346816,38.2107422 C65.2346816,40.9758789 63.7596582,42.6566406 63.2599097,43.2095292 C68.012905,45.060329 70,49.6416016 70,55 L53.8643311,55 C53.8643311,51.6461182 53.283658,46.821167 51.0840735,44.1633367 Z",
      "id": "Oval-2"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57307830"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/classroom_support.vue
// module id = 627
// module chunks = 1